import type {
  APIWorkspaceAttributes,
  APIWorkspaceOverview,
} from '@ardoq/api-types';

/**
 * Build an APIWorkspaceOverview from a workspace we know about locally.
 *
 * Used when a workspace arrives via CREATE/UPDATE WebSocket before the next
 * /api/workspace/overview fetch — the server is the only authoritative source
 * for the count fields, so we preserve them from any prior overview entry.
 */
export const synthesizeOverviewFromWorkspace = (
  workspace: APIWorkspaceAttributes,
  previous?: APIWorkspaceOverview
): APIWorkspaceOverview => ({
  _id: workspace._id,
  _version: workspace._version,
  name: workspace.name,
  created: workspace.created,
  createdBy: workspace.createdBy,
  createdByEmail: workspace.createdByEmail,
  createdByName: workspace.createdByName,
  lastUpdated: workspace.lastUpdated,
  deepLastUpdated: workspace.lastUpdated,
  deepLastModifiedBy: workspace.lastModifiedBy,
  deepLastModifiedByName: workspace.lastModifiedByName,
  deepLastModifiedByEmail: workspace.lastModifiedByEmail,
  gremlinEnabled: workspace.gremlinEnabled,
  componentCount: previous?.componentCount ?? 0,
  referenceCount: previous?.referenceCount ?? 0,
  componentTypeIds: previous?.componentTypeIds ?? [],
});
